// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.methanol_detector_off_reason_enum */
var MethanolDetectorOffReasonEnum;
(function (MethanolDetectorOffReasonEnum) {
    MethanolDetectorOffReasonEnum["CONTAMINATED"] = "CONTAMINATED";
    MethanolDetectorOffReasonEnum["RUN_ENDING"] = "RUN_ENDING";
    MethanolDetectorOffReasonEnum["KNOWN_ISSUE"] = "KNOWN_ISSUE";
    MethanolDetectorOffReasonEnum["OTHER"] = "OTHER";
})(MethanolDetectorOffReasonEnum || (MethanolDetectorOffReasonEnum = {}));
;
export default MethanolDetectorOffReasonEnum;
/** Zod schema for methanol_detector_off_reason_enum */
export const methanolDetectorOffReasonEnum = z.nativeEnum(MethanolDetectorOffReasonEnum);
//# sourceMappingURL=MethanolDetectorOffReasonEnum.js.map